import { createIcon } from '../createIcon.tsx';

export const ArrowUpIcon = createIcon(
	'ArrowUpIcon',
	<>
		<line x1="12" y1="20" x2="12" y2="4" />
		<polyline points="6 10 12 4 18 10" />
	</>,
);
